import React, { useContext, useEffect, useState } from 'react';

import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';
import MemberEducation from './MemberEducation';
import MemberProfile from './MemberProfile';
import { MemberExperience } from './MemberExperience';
import Spacer from '../../../app/common/ui/Spacer';
import { Typography } from '@material-ui/core';
import MemberMiniMenu from '../menus/MemberMiniMenu';
import MemberJurisdiction from './MemberJurisdiction';
import MuiSwitch from '../../../app/common/ui/MuiSwitch';

const MemberProfileContent = () => {
    const { currentUser } = useContext(AuthContext);
    // const currentUser = { uid: 'RoGVkM6usnc7Osr1hVfF2iLPPcv1'}
    const db = useContext(FireDataContext);

    const [profile, setProfile] = useState();
    const [experience, setExperience] = useState([]);
    const [path, setPath] = useState();
    const [member, setMember] = useState();

    useEffect(() => {
        const profileTemplate = {
            title: '',
            summary: '',
            email: currentUser.email,
            phoneNumber: '',
            education: [],
            training: [],
            tariffs: ['tier1', 'defendant']
        };

        setPath(`intermediaries/${currentUser.uid}`);

        db.get({ path: `intermediaries/${currentUser.uid}` })
            .then(data => {
                console.log('member', data)
                if (data) {
                    // if (!member.profile?.tariffs) member.profile?.tariffs
                    setProfile(data?.profile || profileTemplate);
                    setExperience(data.experience || []);
                    setMember(data);
                }
                else {
                    setProfile(profileTemplate)
                }
            })
            .catch(error => {
                console.log('MemberProfilePage db get', error);
            })

    }, [db, currentUser.uid, path, currentUser.email]);

    const handleStateChange = (fragment) => {
        const payload = {
            profile: {
                ...profile,
                ...fragment
            }
        };

        db.update({
            path,
            payload
        })
            .then(() => {
                setProfile(payload.profile)
            })
            .catch(error => console.log(error));
    }

    const handleExperienceChange = selected => {
        setExperience(selected.experience);
        db.update({
            path,
            payload: selected
        });
    }

    const handleHiddenChange = checked => {
        db.update({
            path,
            payload: {
                hidden: checked
            }
        })
            .then(() => {
                setMember({ ...member, hidden: checked })
            })
            .catch(error => console.log(error));
    }

    if (!profile || !member) return <></>

    return (<React.Fragment>
        <MemberProfile profile={profile} onChange={handleStateChange} />
        <Spacer />
        <MemberJurisdiction value={profile.tariffs} onChange={handleStateChange} />
        <Spacer />
        <MemberEducation subject='education' title="Education" items={profile.education} onChange={handleStateChange} />
        <MemberEducation subject='training' title="Relevant Justice Training" items={profile.training} onChange={handleStateChange} />
        <MemberExperience experience={experience} onChange={handleExperienceChange} />
        <Spacer />
        <MuiSwitch label='Switch off referrals (useful for holidays etc)' value={member.hidden} onChange={handleHiddenChange} />
        <Spacer space="3rem" />
        <div style={{ color: '#cfdbd5' }}>
            <Typography variant="h6" >{currentUser.uid}</Typography>
            <Typography variant="h6" >{currentUser.email}</Typography>
        </div>
    </React.Fragment>);
};

const MemberProfilePage = () => {
    return <MemberMiniMenu>
        <MemberProfileContent />
    </MemberMiniMenu>
}

export { MemberProfilePage };